import React, { useState, useEffect } from 'react';
import { FaUserMd, FaStethoscope, FaBriefcase } from 'react-icons/fa';
import { oneKlicks } from '../../../SDK/oneclick';
import { Link } from 'react-router-dom';
import ImageShow from '../../../Uitiles/ImageShow';
import '../../../assets/styles/doctors-list.css';
import { formatUrlString } from '../../../services/apiService';
import DoctorSpecialities from '../../Frontend/Home/Components/DoctorSpecialities';
const demoDoctors = [
    {
        id: 1,
        name: "Dr. John Doe",
        avatar: "https://randomuser.me/api/portraits/men/32.jpg",
        speciality: "Cardiologist",
        experience: 10,
        location: "New York, NY",
    },
    {
        id: 2,
        name: "Dr. Jane Smith",
        avatar: "https://randomuser.me/api/portraits/women/44.jpg",
        speciality: "Dermatologist",
        experience: 8,
        location: "Los Angeles, CA",
    },
    {
        id: 3,
        name: "Dr. Alex Brown",
        avatar: "https://randomuser.me/api/portraits/men/65.jpg",
        speciality: "Pediatrician",
        experience: 12,
        location: "Chicago, IL",
    },
];

const DoctorsList = ({ data }) => {
    console.log('doctors list data:', data);
    const [doctors, setDoctors] = useState([]);
    const [loadtype, setLoadtype] = useState('live');
    // If you want to use real data, replace demoDoctors with data.doctors or similar
    useEffect(() => {
        getDoctors();
        // eslint-disable-next-line
    }, []);

    const getDoctors = async () => {
        const tableSchema = '';
        const tableName = 'hospital_doctors';
        const conditions = {
            hospital_id: data.id,
            //status: "active",
        };
        const orderBy = "RAND()";
        const search = {};
        const pagination = { page: 1, limit: 10 };
        const margedata = [
            {
                target_table: 'users',
                target_column: 'id',
                target_value: 'doctor_id',
                target_label: 'doctors',
                margedata: [
                    {
                        target_table: 'doctor_experience_education',
                        target_column: 'user_id',
                        target_value: 'id',
                        target_label: 'doctor_experience_education'
                    },
                    {
                        target_table: 'doctor_specialities',
                        target_column: 'doctor_id',
                        target_value: 'id',
                        target_label: 'doctor_specialities',
                        margedata: [
                            {
                                target_table: 'specialities',
                                target_column: 'id',
                                target_value: 'speciality_id',
                                target_label: 'specialities'
                            },
                            {
                                target_table: 'services',
                                target_column: 'id',
                                target_value: 'service_id',
                                target_label: 'services'
                            }
                        ]
                    }
                ]
            }
        ];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);


        console.log('doctors list response:', response);


        //console.log('doctors list response:', response);
        if (response.success === true) {
            console.log('doctors list response:', response);
            if (response.data && response.data.length > 0) {
                setLoadtype('live');
                const aggregatedDoctors = response.data.flatMap(item => Array.isArray(item.doctors) ? item.doctors : []);
                if (aggregatedDoctors.length > 0) {
                    setDoctors(aggregatedDoctors);
                } else {
                    setLoadtype('demo');
                    setDoctors(demoDoctors);
                }
            } else {
                setLoadtype('demo');
                setDoctors(demoDoctors);
            }
        } else {
            setLoadtype('demo');
            setDoctors(demoDoctors);
        }
    };

    // Remove duplicate doctors by id before processing
    let uniqueDoctors = [];
    let seenDoctorIds = new Set();

    if (Array.isArray(doctors) && doctors.length > 0) {
        doctors.forEach((doc) => {
            if (doc && doc.id && !seenDoctorIds.has(doc.id)) {
                uniqueDoctors.push(doc);
                seenDoctorIds.add(doc.id);
            }
        });
    }

    // Collect all experiences and educations for all unique doctors, parsed as arrays.
    // Also, calculate total years of experience for each doctor (from earliest start_date to now).
    const allExperiences = [];
    const allEducations = [];
    const doctorExperienceYears = [];

    if (loadtype === 'live' && uniqueDoctors.length > 0) {
        uniqueDoctors.forEach((doc, docIdx) => {
            // Defensive: doctor_experience_education may be missing or empty
            const expEduArr = Array.isArray(doc.doctor_experience_education) ? doc.doctor_experience_education : [];
            if (expEduArr.length > 0) {
                // Parse experiences
                let experiencesArr = [];
                let educationsArr = [];
                try {
                    if (expEduArr[0].experiences) {
                        if (typeof expEduArr[0].experiences === 'string') {
                            experiencesArr = JSON.parse(expEduArr[0].experiences);
                        } else if (Array.isArray(expEduArr[0].experiences)) {
                            experiencesArr = expEduArr[0].experiences;
                        }
                    }
                } catch (e) {
                    experiencesArr = [];
                }
                try {
                    if (expEduArr[0].educations) {
                        if (typeof expEduArr[0].educations === 'string') {
                            educationsArr = JSON.parse(expEduArr[0].educations);
                        } else if (Array.isArray(expEduArr[0].educations)) {
                            educationsArr = expEduArr[0].educations;
                        }
                    }
                } catch (e) {
                    educationsArr = [];
                }
                allExperiences.push(experiencesArr);
                allEducations.push(educationsArr);

                // Calculate years of experience for this doctor
                let minStart = null;
                const now = new Date();
                experiencesArr.forEach(exp => {
                    if (exp && exp.start_date) {
                        const start = new Date(exp.start_date);
                        if (!isNaN(start)) {
                            if (!minStart || start < minStart) {
                                minStart = start;
                            }
                        }
                    }
                });
                let years = 0;
                if (minStart) {
                    years = now.getFullYear() - minStart.getFullYear();
                    // Adjust if the current month/day is before the start month/day
                    if (
                        now.getMonth() < minStart.getMonth() ||
                        (now.getMonth() === minStart.getMonth() && now.getDate() < minStart.getDate())
                    ) {
                        years -= 1;
                    }
                }
                // Attach experience years to the doctor object
                doc.experience = years;
                doctorExperienceYears.push(years);
                console.log('doctor full data:', doc);
            } else {
                allExperiences.push([]);
                allEducations.push([]);
                doctorExperienceYears.push(0);
            }
        });
    }

    // Group doctor_specialities by speciality_id with null checks
    // Collect all unique specialities' names for all unique doctors
    const allSpecialityNames = [];

    if (uniqueDoctors.length > 0) {
        uniqueDoctors.forEach((doc, docIdx) => {
            if (Array.isArray(doc.doctor_specialities)) {
                doc.doctor_specialities.forEach((specObj) => {
                    // Each doctor_specialities item may have a 'specialities' array
                    if (Array.isArray(specObj.specialities)) {
                        specObj.specialities.forEach((spec) => {
                            if (spec && spec.name) {
                                allSpecialityNames.push(spec.name);
                            }
                        });
                    }
                });
            }
        });
    }

    // Remove duplicates
    const uniqueSpecialityNames = [...new Set(allSpecialityNames)];

    // For debugging: show all unique specialities' names and doctors data
    console.log('All unique specialities names:', uniqueSpecialityNames);
    console.log('All doctors data:', uniqueDoctors);

    

    const encryptId = (id) => {
        const salt = 'meddylist';
        const encrypted = btoa(id + salt);
        return encrypted;
    };

    return (
        <div className="tab-content dc-contentdoctab dc-haslayout ww">
            <div className="dc-userdetails-holder tab-pane active show doctors-list-tab-content" id="userdetails">
                <div className="dc-aboutdoc dc-aboutinfo doctors-list-about-section" style={{marginBottom: 0}}>
                    <div className="dc-infotitle doctors-list-info-title">
                        <h3>
                            <FaUserMd />
                            Our Doctors
                        </h3>
                        <p className="text-muted doctors-list-info-subtitle" style={{marginBottom: 0}}>
                            Meet our experienced and caring medical professionals.
                        </p>
                    </div>
                </div>
                <div className="dc-doctors-list-grid doctors-list-grid">
                    {doctors.length > 0 ? (
                        doctors.map((doc) => (
                            <div
                                key={doc.id}
                                className="doctor-card doctors-list-doctor-card col-lg-6 col-md-6 col-sm-12 col-xs-12"
                            >
                                <ImageShow 
                                    url={doc.profile_photo_url || "/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png"} 
                                    height={80} 
                                    width={80} 
                                    style={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        marginBottom: 16,
                                        border: "3px solid #e9ecef",
                                    }}
                                />
                            
                                <h5 className="doctors-list-doctor-name">{loadtype === 'live' ? doc.display_name : doc.name}</h5>
                                <div className="doctors-list-doctor-speciality">
                                    <FaStethoscope />
                                    <DoctorSpecialities doctorId={doc.id} data={doc || []} type="list" />
                                </div>
                                <div className="doctors-list-doctor-experience">
                                    <FaBriefcase />
                                    {loadtype === 'live' ? (
                                        <span>
                                            {doc.experience} years experience
                                        </span>
                                    ) : (
                                        <p>{doc.experience} years experience</p>
                                    )}
                                </div>
                                
                                <Link
                                    className="btn btn-outline-primary doctors-list-view-profile-btn"
                                    to={`/doctor/dr-${formatUrlString(doc.display_name)}/${encryptId(doc.id)}`}
                                >
                                    View Profile
                                </Link>
                            </div>
                        ))
                    ) : (
                        <div className="dc-no-doctors doctors-list-no-doctors">
                            <p>No doctors found</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DoctorsList;
